var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.limit,"prev-text":_vm.$t('prevText'),"next-text":_vm.$t('nextText'),"total":_vm.num},on:{"current-change":_vm.pageOffset}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8a6244","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/pagination.vue
// module id = null
// module chunks = 